import React from 'react';
import { Tag } from 'antd';

import { RightSidebar } from "src/pages/_partials/Layout";
import { CdrInterface } from "src/store/callrecorder/cdrsSlice";
import RowInfo from "src/componets/RowInfo";
import { formattedDate } from "src/helpers/DateHelpers";
import OptionalLink from "src/componets/OptionalLink";
import callrecorderUrls from "src/configs/callrecorder/callrecorderUrls";

const _SidebarShow = ({ record }: { record: CdrInterface | undefined }) => {
  const dispositionColor = (disposition: string | null) => {
    switch (disposition) {
      case 'ANSWERED': return 'success';
      case 'NO ANSWER': return 'warning';
      case 'BUSY': return 'orange';
      case 'FAILED': return 'error';
      case 'CANCEL': return 'default';
      default: return 'default';
    }
  };

  const callTypeColor = (callType: string | null) => {
    switch (callType) {
      case 'incoming': return 'blue';
      case 'outgoing': return 'green';
      case 'reminder': return 'purple';
      default: return 'default';
    }
  };

  const formatDuration = (seconds: number) => {
    const m = Math.floor(seconds / 60);
    const s = seconds % 60;
    return m > 0 ? `${m}m ${s}s` : `${s}s`;
  };

  const renderDetails = () => {
    if (!record) {
      return null;
    }

    return (
      <>
        <div className='v-mb-20'>
          <h6 className='v-content-label o-sm'>Identity</h6>

          <RowInfo left='#ID' right={record.id} />
          <RowInfo left='User' right={
            record.user_id ? (
              <OptionalLink link={callrecorderUrls.userPath(record.user_id)}>
                {`#${record.user_id}`}
              </OptionalLink>
            ) : '—'
          } />
          <RowInfo left='Unique ID' right={record.uniqueid ? <small>{record.uniqueid}</small> : '—'} />
          <RowInfo left='Linked ID' right={record.linkedid ? <small>{record.linkedid}</small> : '—'} />
        </div>

        <div className='v-mb-20'>
          <h6 className='v-content-label o-sm'>Call Info</h6>

          <RowInfo left='Disposition' right={
            record.disposition ? <Tag color={dispositionColor(record.disposition)}>{record.disposition}</Tag> : '—'
          } />
          <RowInfo left='Call Type' right={
            record.call_type ? <Tag color={callTypeColor(record.call_type)}>{record.call_type}</Tag> : '—'
          } />
          <RowInfo left='Src' right={record.src || '—'} />
          <RowInfo left='Dst' right={record.dst || '—'} />
          <RowInfo left='CLID' right={record.clid ? <small>{record.clid}</small> : '—'} />
          <RowInfo left='Duration' right={formatDuration(record.duration)} />
          <RowInfo left='Billsec' right={formatDuration(record.billsec)} />
        </div>

        <div className='v-mb-20'>
          <h6 className='v-content-label o-sm'>Timestamps</h6>

          <RowInfo left='Call Date' right={record.calldate ? formattedDate(record.calldate).dateTime : '—'} />
          <RowInfo left='Start Call' right={record.start_call ? formattedDate(record.start_call).dateTime : '—'} />
          <RowInfo left='Answer' right={record.answer ? formattedDate(record.answer).dateTime : '—'} />
          <RowInfo left='End Call' right={record.end_call ? formattedDate(record.end_call).dateTime : '—'} />
        </div>

        <div className='v-mb-20'>
          <h6 className='v-content-label o-sm'>Channel</h6>

          <RowInfo left='Channel' right={record.channel ? <small>{record.channel}</small> : '—'} />
          <RowInfo left='Dst Channel' right={record.dstchannel ? <small>{record.dstchannel}</small> : '—'} />
          <RowInfo left='Last App' right={record.lastapp || '—'} />
          <RowInfo left='Last Data' right={record.lastdata ? <small>{record.lastdata}</small> : '—'} />
          <RowInfo left='Context' right={record.dcontext || '—'} />
        </div>

        <div className='v-mb-20'>
          <h6 className='v-content-label o-sm'>Other</h6>

          <RowInfo left='Account Code' right={record.accountcode || '—'} />
          <RowInfo left='Peer Account' right={record.peeraccount || '—'} />
          <RowInfo left='User Field' right={record.userfield || '—'} />
          <RowInfo left='AMA Flags' right={record.amaflags} />
          <RowInfo left='Sequence' right={record.sequence} />
          <RowInfo left='IP Address' right={record.ipaddr || '—'} />
        </div>

        <div className='v-mb-20'>
          <h6 className='v-content-label o-sm'>References</h6>

          <RowInfo left='Rate' right={record.rate_id ? `#${record.rate_id}` : '—'} />
          <RowInfo left='Reminder Activity' right={record.reminder_activity_id ? `#${record.reminder_activity_id}` : '—'} />
        </div>
      </>
    )
  }

  return (
    <RightSidebar>
      <h6 className='v-content-label'>CDR DETAILS</h6>
      <hr className="v-divider" />

      {renderDetails()}
    </RightSidebar>
  )
}

export default _SidebarShow;
